var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.885 12L18 15.885L14.115 12L12 14.115L15.885 18L12 21.885L14.115 24L18 20.115L21.885 24L24 21.885L20.115 18L24 14.115L21.885 12ZM18 3C9.705 3 3 9.705 3 18C3 26.295 9.705 33 18 33C26.295 33 33 26.295 33 18C33 9.705 26.295 3 18 3Z",
    fill: "#FA3434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertErrorIcon);
export default __webpack_public_path__ + "static/media/alert-error-icon.2caacba8d82bd1a39b72637c85da1deb.svg";
export { ForwardRef as ReactComponent };